module.exports = __webpack_public_path__ + "assets/img/Chengdu.103536e1.jpg";